import Heading from 'LuxKit/Typography/Heading'

interface Props {
  intro: string
  highlight?: string
}

function ImageTitle({ intro, highlight }: Props) {
  return <>
    <Heading variant="heading2" colour="neutral-eight" align="center">
      {intro}
    </Heading>
    {highlight && <Heading variant="heading2alt" colour="neutral-eight" align="center">
      {highlight}
    </Heading>}
  </>
}

export default ImageTitle
